import {
  FLASH_MESSAGE_SET_POSITION,
  FLASH_MESSAGE_RESET_POSITION,
  FLASH_MESSAGE_SET_WARNING_MESSAGE,
  FLASH_MESSAGE_SET_ERROR_MESSAGE
} from "./mutations.type";

const DEFAULT_POSITION = "right bottom";
const state = {
  position: DEFAULT_POSITION,
  warningMessage: null,
  flashErrorMessage: null
};

const getters = {
  flashMessagePosition(state) {
    return state.position;
  },
  warningMessage(state) {
    return state.warningMessage;
  },
  flashErrorMessage(state) {
    return state.flashErrorMessage;
  }
};

const mutations = {
  [FLASH_MESSAGE_SET_POSITION](state, position) {
    state.position = position;
  },
  [FLASH_MESSAGE_RESET_POSITION](state) {
    state.position = DEFAULT_POSITION;
  },
  [FLASH_MESSAGE_SET_WARNING_MESSAGE](state, message) {
    state.warningMessage = message;
  },
  [FLASH_MESSAGE_SET_ERROR_MESSAGE](state, message) {
    if (typeof message === "string") state.flashErrorMessage = message;
  }
};

export default {
  state,
  getters,
  mutations
};
